module.exports = require("./BladeManager");


//////////////////
// WEBPACK FOOTER
// external "./BladeManager"
// module id = 9
// module chunks = 2